import React, { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import { BasicContainer } from '@minecraft.atoms';

export const WalletLoader: FC = () => {
  return (
    <BasicContainer
      borderRadius="md"
      className="cn_w-full"
      padding={4}
      borderPlacement="all"
      data-testid="wallet-loader"
    >
      <Skeleton height="3rem" />
    </BasicContainer>
  );
};
